import React, { useState } from 'react';
import './HistoryPage.css';

// import React from 'react';
import { useNavigate } from 'react-router-dom';

function HistoryPage({ selectedCrop }) {
  // Example data for the tabulated history
  const historyData = [
    { month: "January", year: 2025, areaofland: 5000, rate: 1700 },
    { month: "February", year: 2025, areaofland: 4800, rate: 2000 },
    { month: "March", year: 2025, areaofland: 3200, rate: 1500 },
    { month: "April", year: 2025, areaofland: 3500, rate: 1400 },
    { month: "May", year: 2025, areaofland: 4200, rate: 1900 },
    { month: "June", year: 2025, areaofland: 4650, rate: 2000 },
    { month: "July", year: 2025, areaofland: 6500, rate: 1800 },
    { month: "August", year: 2025, areaofland: 2500, rate: 1400 },
    { month: "September", year: 2025, areaofland: 5400, rate: 2500 },
    { month: "October", year: 2025, areaofland: 4450, rate: 2000 },
    { month: "November", year: 2025, areaofland: 4850, rate: 1500 },
    { month: "December", year: 2025, areaofland: 4810, rate: 1600 }
    // Add more data for other years here
  ];

  const navigate = useNavigate();

  const handleNextClick = () => {
    navigate(`/current-data/${selectedCrop}`);
  };

  return (
    <div className="history-page">
      <h1 style={{fontSize:"45px"}}>Last year History for {selectedCrop}</h1>
      <table class="styled-table">
        <thead>
          <tr>
            <th style={{fontSize: "25px", fontStyle: "bold", textAlign: "left"}}>Month and Year of Plantation</th>
            <th style={{fontSize: "25px", fontStyle: "bold", textAlign: "left"}}>Rate (in Rupees)</th>
            <th style={{fontSize: "25px", fontStyle: "bold", textAlign: "left"}}>Area of land (in acres)</th>
          </tr>
        </thead>
        <tbody>
          {historyData.map((entry, index) => (
            <tr key={index}>
              <td style={{fontSize: "20px", textAlign: "left"}}>{entry.month}, {entry.year}</td>
              <td style={{fontSize: "20px", textAlign: "left"}}>{entry.rate}</td>
              <td style={{fontSize: "20px", textAlign: "left"}}>{entry.areaofland}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <button id="next-button" onClick={handleNextClick}>Next</button>
    </div>
  );
}

export default HistoryPage;
